// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Family } from './family';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ChristianEducationSupport extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  childrenInProgram?: number;
  familyContribution?: number;
  familyId!: number;
  grades?: string;
  notes?: string;
  otherContribution?: number;
  school?: string;
  schoolYear!: number;
  totalTuition?: number;
  family!: Family;
}

